@if (isLinkUp()) {
  <ix-icon
    #stateIcon
    name="ix:network_upload_download"
    [id]="elementId"
    [matTooltip]="tooltipText()"
  ></ix-icon>
} @else {
  <ix-icon name="ix:network_upload_download_disabled"></ix-icon>
}


